export default __webpack_public_path__ + "static/layout-anatomy-light-0f40a152ed8a1c803cfbace1b8c531c8f27d7cb8b413f6efdca5266099dfb3f9.png";